// 构建map示例并载入对应文件

function loadScript(url: String, apiName: any) {
    return new Promise((resolve: Function, reject: Function) => {
        const $el: any = document.createElement('script');
        $el.src = url;
        $el.type = 'text/javascript'
        $el.onload = () => {
            resolve(window[apiName]);
        };
        $el.onerror = () => {
            reject(new Error('mapjs script loaded fail~'));
        };
        document.body.appendChild($el);
    });
};

export async function initMap(src: String, apiName: any) {
    if (window[apiName]) {
        // 加载过的文件不在重复加载
        return new Promise((resolve) => {
            resolve(window[apiName])
        })
    } else {
        return await loadScript(src, apiName)
    }
}

export function getMapApi(map: any, id: string) {
    if (map.Map) return new map.Map(id)
}
